export default __webpack_public_path__ + "static/media/CNo.60-4.809ed1f2.jpg";